// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WpyJ","clinicsSelect":"styles_clinicsSelect__Xtlaj"};